import React, { Component } from 'react'
import GallaryCard from 'components/GallaryCard';
import { log } from 'utils';

class CarouselComp extends Component {
    constructor(props) {
        super(props);

        this.state={
            leftValue: 0
        }
        
        this.scrollContentNext = this.scrollContentNext.bind(this);
        this.scrollContentPrev = this.scrollContentPrev.bind(this);
        this.renderScrollButtons = this.renderScrollButtons.bind(this);
    }

    scrollContentNext() {
        let sliderWidth = 280 *  this.props.messageArray.length;
        // ev.target.parentNode.parentNode.parentNode.getElementsByClassName('carousel-inner-wrapper-container')[0].offsetWidth ;
        let tempLeftValue;
        if(this.state.leftValue <= -(sliderWidth - 280)) {
            log('LeastReached');
            this.setState({
                leftValue: 0
            })
        } else {
            tempLeftValue = (this.state.leftValue - 280);
            this.setState({
                leftValue: tempLeftValue
            })
        }
        log(tempLeftValue, sliderWidth, 'Next');
    }

    scrollContentPrev() {
        let sliderWidth = 280 *  this.props.messageArray.length
        // ev.target.parentNode.parentNode.parentNode.getElementsByClassName('carousel-inner-wrapper-container')[0].offsetWidth;
        let tempLeftValue;
        if(this.state.leftValue >= 0) {
            log('MaxReached');
            this.setState({
                leftValue: -(sliderWidth - 280)
            })
        } else {
            tempLeftValue = (this.state.leftValue + 280);
            this.setState({
                leftValue: tempLeftValue
            })
        }
        log(tempLeftValue, sliderWidth, 'Prev');
    }

    renderScrollButtons(arrayLength) {
        if (arrayLength <= 1) return;

        return(
            <div className="carousel-btns">
                <div className="carousel-prev-btn">
                    <span className="carousel-btn-content" onClick={this.scrollContentPrev}>&#10094;</span>
                </div>
                <div className="carousel-next-btn">
                    <span className="carousel-btn-content" onClick={this.scrollContentNext}>&#10095;</span>
                </div>
            </div>
        )
    }

    render() {
        const customStyle = {
            marginLeft: this.state.leftValue + 'px ',
            width : this.props.messageArray.length * 100 + '%'
        };

        return (
            <div className="carousel-container">
                <div className="carousel-wrapper-container">
                    {this.renderScrollButtons(this.props.messageArray.length)}
                    <div className="carousel-inner-wrapper-container" style={customStyle} >
                    {
                        this.props.messageArray.map((option, i) => {
                            if(!option.panel) return
                            return (
                                <div key={i} className="carousel-inner-flex-container">
                                    <GallaryCard message={option} />
                                </div>
                            )
                        })
                    }
                    </div>
                </div>
            </div>
        )
    }
}

export default CarouselComp;



// WEBPACK FOOTER //
// ./src/components/CarouselComp.js